// extracted by mini-css-extract-plugin
module.exports = {"bots":"bots_bots__2AtZm","title":"bots_title__3WBAQ","bot":"bots_bot__2W1Cv","active":"bots_active__1D6Kb"};